export enum Status {
  ACTIVE = 1,
  WILL_BE_ACTIVATED = 2,
  DISABLED = 3,
  HAS_NOT = 4,
  SUSPEND = 5,
  NO_DEMO_OR_ORIGINAL_CONSTRACT = 6,
  USING_FREE_DEMO = 7,
}
export enum PackagesRoutes {
  ELEMENTARY_SCHOOL = "elementary-school-packages",
  MIDDLE_SCHOOL = "middle-school-packages",
  HIGHSCHOOL = "highschool-packages",
}
export enum SortType {
  BEST_SELLING = 1,
  SCORE = 2,
  NUMBER_OF_POINTS = 3,
}
export enum SeriIdEnum {
  NOROUZ_LEAGUE = 22,
  COMPREHENSIVE = 19,
}

export enum ProductTypesEnum {
  BANKB2B = 1,
  BANKB2C = 2,
  EXAM_MARKET = 3,
  MONTA_ACADEMY = 4,
  ONLINE_CLASS = 5,
  ONLINE_EXAM = 6,
  OFFLINE_EXAM = 7,
  AUTOMATION = 8,
  SMS_PANEL = 10,
  EDUCATION_PACK = 11,
}
